var map = {
	"./1/symbol_0.png": "dec8",
	"./1/symbol_1.png": "fc32",
	"./1/symbol_10.png": "e4a2",
	"./1/symbol_11.png": "ab92",
	"./1/symbol_12.png": "f7fc",
	"./1/symbol_2.png": "b656",
	"./1/symbol_3.png": "d449",
	"./1/symbol_4.png": "3a51",
	"./1/symbol_5.png": "6d1b",
	"./1/symbol_6.png": "3d31",
	"./1/symbol_7.png": "7819",
	"./1/symbol_8.png": "a711",
	"./1/symbol_9.png": "0534",
	"./2/symbol_0.png": "2ecd",
	"./2/symbol_1.png": "269f",
	"./2/symbol_10.png": "7c62",
	"./2/symbol_11.png": "6915",
	"./2/symbol_12.png": "1abf",
	"./2/symbol_2.png": "4168",
	"./2/symbol_3.png": "96a3",
	"./2/symbol_4.png": "65e7",
	"./2/symbol_5.png": "134e",
	"./2/symbol_6.png": "ac89b",
	"./2/symbol_7.png": "1ab1",
	"./2/symbol_8.png": "c5e8",
	"./2/symbol_9.png": "411a",
	"./3/symbol_0.png": "d2ba",
	"./3/symbol_1.png": "44f5",
	"./3/symbol_10.png": "6006",
	"./3/symbol_12.png": "9921",
	"./3/symbol_2.png": "afdd",
	"./3/symbol_3.png": "ce96",
	"./3/symbol_4.png": "6037",
	"./3/symbol_5.png": "2514e",
	"./3/symbol_6.png": "88b7",
	"./3/symbol_7.png": "3e7a",
	"./3/symbol_8.png": "3777",
	"./3/symbol_9.png": "917d",
	"./4/symbol_0.png": "1055",
	"./4/symbol_1.png": "e328",
	"./4/symbol_10.png": "f1d2",
	"./4/symbol_12.png": "621f",
	"./4/symbol_2.png": "9fc0",
	"./4/symbol_3.png": "48e2",
	"./4/symbol_4.png": "34ab",
	"./4/symbol_5.png": "a7c1",
	"./4/symbol_6.png": "7af7",
	"./4/symbol_7.png": "7c89",
	"./4/symbol_8.png": "fcdc",
	"./4/symbol_9.png": "8fe7",
	"./gold1.png": "1c3b",
	"./gold2.png": "fbe2",
	"./gold3.png": "f62d",
	"./gold4.png": "1f7d",
	"./silver1.png": "9675",
	"./silver2.png": "a363",
	"./silver3.png": "3477",
	"./silver4.png": "6737"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eb95";